export default __webpack_public_path__ + "static/OgImage-38bf9df262e121db77e017aba1a11a39.jpg";